(function defineBundleShopifyVariants() {
	if (customElements.get('bundle-shopify-variants')) {
		return;
	}
	const Base = customElements.get('product-variants');
	if (!Base) {
		setTimeout(defineBundleShopifyVariants, 50);
		return;
	}
	customElements.define('bundle-shopify-variants', class extends Base {});
})();

if (typeof BundleShopifyPicker !== 'function') {
	class BundleShopifyPicker extends HTMLElement {
		constructor() {
			super();
			this.init();
		}

		init() {
			this.sectionId = this.dataset.sectionId;
			this.mode = this.dataset.mode || 'parent';
			this.form = document.getElementById(`product-form-${this.sectionId}`)
				|| document.querySelector(`#add-to-cart-${this.sectionId} form`);

			if (this.mode !== 'components') {
				return;
			}

			this.components = this._readJson('[data-bundle-components]') || [];
			this.parentVariants = this._readJson('[data-bundle-parent-variants]') || [];
			this.addEventListener('change', this.sync.bind(this));
			this.sync();
		}

		_readJson(selector) {
			const node = this.querySelector(selector);
			if (!node) return null;
			try {
				return JSON.parse(node.textContent);
			} catch (error) {
				return null;
			}
		}

		_selectedOptionsFor(componentId) {
			const options = [];
			this.querySelectorAll(`[data-bundle-component-option][data-component-id="${componentId}"]`).forEach((row) => {
				const checked = row.querySelector('input:checked');
				if (checked) {
					options[parseInt(row.dataset.optionIndex, 10)] = checked.value;
				}
			});
			return options;
		}

		_findComponentVariant(component) {
			const selected = this._selectedOptionsFor(component.id);
			if (!component.variants || !component.variants.length) {
				return null;
			}
			if (component.options && component.options.length === 0) {
				return component.variants[0];
			}
			return component.variants.find((variant) => {
				return !variant.options.map((option, index) => selected[index] === option).includes(false);
			}) || null;
		}

		_findParentVariant(componentVariants) {
			if (!this.parentVariants.length) {
				return null;
			}
			if (this.parentVariants.length === 1) {
				return this.parentVariants[0];
			}

			const selectedValues = componentVariants
				.filter(Boolean)
				.flatMap((variant) => variant.options || [variant.option1, variant.option2, variant.option3].filter(Boolean));

			return this.parentVariants.find((variant) => {
				const parentValues = variant.options || [variant.option1, variant.option2, variant.option3].filter(Boolean);
				return selectedValues.every((value) => parentValues.includes(value));
			}) || this.parentVariants.find((variant) => variant.available) || this.parentVariants[0];
		}

		_markUnavailable(component, selectedVariant) {
			const rows = this.querySelectorAll(`[data-bundle-component-option][data-component-id="${component.id}"]`);
			if (!rows.length || !component.variants) {
				return;
			}

			rows.forEach((row, optionIndex) => {
				row.querySelectorAll('.product-variant-value').forEach((input) => {
					input.classList.remove('disabled');
					input.removeAttribute('disabled');
					const value = input.value;
					const possible = component.variants.some((variant) => {
						if (variant.options[optionIndex] !== value) {
							return false;
						}
						return row === rows[0] ? variant.available : this._matchesOtherSelections(variant, component.id, optionIndex);
					});
					if (!possible) {
						input.classList.add('disabled');
						input.setAttribute('disabled', 'disabled');
					}
				});
			});

			if (selectedVariant && !selectedVariant.available) {
				rows.forEach((row) => {
					const checked = row.querySelector('input:checked');
					if (checked) {
						checked.classList.add('disabled');
					}
				});
			}
		}

		_matchesOtherSelections(variant, componentId, currentIndex) {
			const selected = this._selectedOptionsFor(componentId);
			return variant.options.every((option, index) => {
				if (index === currentIndex) {
					return true;
				}
				return !selected[index] || selected[index] === option;
			}) && variant.available;
		}

		_ensureHiddenInput(name, value) {
			if (!this.form) {
				return;
			}
			let input = this.form.querySelector(`input[name="${name}"]`);
			if (!input) {
				input = document.createElement('input');
				input.type = 'hidden';
				input.name = name;
				this.form.appendChild(input);
			}
			input.value = value;
		}

		sync() {
			const selectedVariants = this.components.map((component) => {
				const variant = this._findComponentVariant(component);
				this._markUnavailable(component, variant);
				return variant;
			});

			const allSelected = selectedVariants.every(Boolean);
			const allAvailable = selectedVariants.every((variant) => variant && variant.available);
			const parentVariant = this._findParentVariant(selectedVariants);

			if (this.form && parentVariant) {
				const idInput = this.form.querySelector('input[name="id"]');
				if (idInput) {
					idInput.value = parentVariant.id;
					idInput.dispatchEvent(new Event('change', { bubbles: true }));
				}
			}

			const summary = this.components.map((component, index) => {
				const variant = selectedVariants[index];
				if (!variant) {
					return `${component.title}`;
				}
				const variantTitle = variant.title && variant.title !== 'Default Title' ? ` - ${variant.title}` : '';
				return `${component.title}${variantTitle}`;
			}).join(' | ');

			this._ensureHiddenInput('properties[_Bundle components]', summary);

			const addToCart = document.querySelector(`#add-to-cart-${this.sectionId} [data-js-product-add-to-cart]`);
			const addToCartText = document.querySelector(`#add-to-cart-${this.sectionId} [data-js-product-add-to-cart-text]`);
			const productForm = document.querySelector(`#add-to-cart-${this.sectionId} form`);

			if (!addToCart || !addToCartText) {
				return;
			}

			if (!allSelected || !allAvailable || (parentVariant && parentVariant.available === false)) {
				addToCart.classList.add('disabled');
				if (productForm) {
					productForm.classList.add('disabled-cart');
				}
				addToCartText.textContent = KROWN.settings.locales.products_sold_out_variant;
			} else {
				addToCart.classList.remove('disabled');
				if (productForm) {
					productForm.classList.remove('disabled-cart');
				}
				addToCartText.textContent = addToCartText.hasAttribute('data-show-preorder-wording')
					? KROWN.settings.locales.products_preorder_button
					: KROWN.settings.locales.products_add_to_cart_button;
			}
		}
	}

	if (typeof customElements.get('bundle-shopify-picker') === 'undefined') {
		customElements.define('bundle-shopify-picker', BundleShopifyPicker);
	}
}

(function keepBundlePickerVisible() {
	const root = document.querySelector('.product--bundle-shopify') || document.body;
	if (!document.body.classList.contains('template-product-bundle-shopify') && !document.querySelector('.product--bundle-shopify')) {
		return;
	}

	const show = (el) => {
		if (!el) return;
		el.hidden = false;
		el.removeAttribute('hidden');
		el.removeAttribute('aria-hidden');
		el.style.setProperty('display', 'block', 'important');
		el.style.setProperty('opacity', '1', 'important');
		el.style.setProperty('visibility', 'visible', 'important');
		el.style.setProperty('position', 'static', 'important');
		el.style.setProperty('width', 'auto', 'important');
		el.style.setProperty('height', 'auto', 'important');
		el.style.setProperty('max-height', 'none', 'important');
		el.style.setProperty('overflow', 'visible', 'important');
		el.style.setProperty('clip', 'auto', 'important');
		el.style.setProperty('pointer-events', 'auto', 'important');
	};

	let updating = false;
	const protect = () => {
		if (updating) return;
		updating = true;
		document.querySelectorAll('variant-swatch-king').forEach((el) => {
			el.hidden = true;
			el.setAttribute('aria-hidden', 'true');
			el.style.setProperty('display', 'none', 'important');
		});
		document.querySelectorAll('bundle-shopify-picker, bundle-shopify-variants, .bundle-shopify-picker__options, .bundle-shopify-picker .product-variant').forEach(show);
		updating = false;
	};

	protect();
	[150, 400, 900, 1600, 3000].forEach((delay) => setTimeout(protect, delay));
	const observer = new MutationObserver(protect);
	observer.observe(root, { childList: true, subtree: true });
})();
